var React = require('react');

function Hammer48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M50.998 14c0 .266-.105.52-.293.707l-5.999 6a1.001 1.001 0 0 1-1.416 0l-7.291-7.291-11.575 11.578.254.254a1 1 0 0 1 .214 1.098l-2.97 7.04c-.05.119-.123.226-.214.319L7.709 47.702a.994.994 0 0 1-1.415 0l-6-5.999a1 1 0 0 1 0-1.417l13.998-13.998a.965.965 0 0 1 .307-.208l6.968-3.045a.997.997 0 0 1 1.109.209l.332.333L34.583 12 24.292 1.709A1.001 1.001 0 0 1 25 0h11.998c.265 0 .52.106.708.293l4.748 4.747.829-.83a1.001 1.001 0 1 1 1.416 1.417l-.829.83 6.835 6.834a.999.999 0 0 1 .293.709zM22.303 25.704l-.002-.002-.002-.002-.556-.556-6.169 2.694L2.418 40.995l4.584 4.582 13.153-13.152 2.631-6.238-.483-.483zM36.584 2.003h-9.166l16.58 16.578L48.581 14 36.584 2.003z","key":1})]);
}

Hammer48px.displayName = "Hammer48px";

Hammer48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 51 48"};

module.exports = Hammer48px;

Hammer48px.default = Hammer48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/hammer-48px.svg
// module id = 1141
// module chunks = 0